// Bannière d'annonces globales (info / important / urgent)
import { Info, AlertTriangle, Siren, X } from "lucide-react";
import api from "@/lib/api";

const STYLES = {
  info: { classe: "bg-success/15 border-success/40 text-foreground", Icone: Info, iconClasse: "text-success" },
  important: { classe: "bg-primary/15 border-primary/40 text-foreground", Icone: AlertTriangle, iconClasse: "text-primary" },
  urgent: { classe: "bg-destructive text-destructive-foreground border-destructive", Icone: Siren, iconClasse: "text-destructive-foreground" },
};

export const AnnouncementBanner = ({ annonces, onDismiss }) => {
  if (!annonces?.length) return null;

  const fermer = async (id) => {
    try {
      await api.post(`/announcements/${id}/dismiss`);
    } catch (e) {
      // fermeture locale même en cas d'échec réseau
    }
    onDismiss(id);
  };

  return (
    <div className="space-y-3" data-testid="announcement-banner">
      {annonces.map((a) => {
        const style = STYLES[a.niveau] || STYLES.info;
        const { Icone } = style;
        return (
          <div
            key={a.id}
            className={`flex items-start gap-3 rounded-xl border px-4 py-3 apparition ${style.classe}`}
            data-testid={`announcement-${a.niveau}`}
          >
            <Icone className={`h-5 w-5 mt-0.5 shrink-0 ${style.iconClasse}`} />
            <div className="flex-1 min-w-0">
              <p className="font-semibold">{a.titre}</p>
              <p className="text-sm opacity-90">{a.message}</p>
            </div>
            <button
              onClick={() => fermer(a.id)}
              className="p-1 rounded-full hover:bg-foreground/10 transition-colors"
              aria-label="Fermer l'annonce"
              data-testid={`announcement-dismiss-${a.id}`}
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        );
      })}
    </div>
  );
};
